export default {
    props: {
        title: {
            type: String,
            //  required:true,
            default () {
                return ''
            }
        }
    },
    name: 'cardBody',
    components: {

    },
    data() {
        return {

        }
    },
    methods: {

    }
}